// extracted by css-extract-rspack-plugin
export default {"formElement":"formElement__LSDJs","voiceControlCheckboxDescription":"voiceControlCheckboxDescription__vyj0J"};